import { useEffect, useRef, useState } from "react"
import { Tooltip as ReactTooltip } from "react-tooltip"
import styled from "styled-components"

import { useGetInAppUnreadCountQuery } from "store/api/notificationApi"
import { ReactComponent as BellIcon } from "assets/svg/menu-notification.svg"

import { NotificationCenterModal } from "modals/NotificationCenterModal"

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 40px;
  height: 40px;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
  }

  svg {
    width: 40px;
    height: 40px;
  }
`

const Badge = styled.div`
  position: absolute;
  top: 2px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 2px;
  background: #ef4444;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 11px;
  color: white;
`

const StyledTooltip = styled(ReactTooltip)`
  background-color: white !important;
  color: #475569 !important;
  font-size: 12px !important;
  padding: 7px 10px !important;
  border-radius: 6px !important;
  border: 1px solid rgb(226 232 240 / 100%) !important;
  box-shadow: 0 12px 24px 0 rgb(148 163 184 / 12%) !important;
  z-index: 4100;
`

export const NotificationIcon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const iconRef = useRef<HTMLDivElement>(null)
  const tooltipId = "tooltip-notification-center"

  const { data, refetch } = useGetInAppUnreadCountQuery()

  useEffect(() => {
    const interval = setInterval(() => {
      refetch()
    }, 60000)

    return () => clearInterval(interval)
  }, [refetch])

  const handleClick = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleClose = () => {
    setIsModalOpen(false)
  }

  const unreadCount = data?.data || 0
  const hasUnread = unreadCount > 0
  const displayCount = unreadCount > 99 ? "99+" : unreadCount

  return (
    <>
      <IconWrapper ref={iconRef} onClick={handleClick} data-tooltip-id={tooltipId} aria-label="Notification Center">
        <BellIcon />
        {hasUnread && <Badge>{displayCount}</Badge>}
      </IconWrapper>
      <StyledTooltip delayShow={500} id={tooltipId}>
        Notification Center
      </StyledTooltip>
      {isModalOpen && <NotificationCenterModal onClose={handleClose} triggerRef={iconRef} />}
    </>
  )
}
